import { render, staticRenderFns } from "./LoadInViewport.vue?vue&type=template&id=bfa00b0a&"
import script from "./LoadInViewport.vue?vue&type=script&lang=js&"
export * from "./LoadInViewport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports